<template>
  <footer class="footer">
    <div class="container">
      <div class="footer__text">© 2021 ТОВ «Нова Пошта»</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'FooterComponent'
}
</script>

<style scoped lang="scss">
@import "../assets/styles/parts/variables";
@import "../assets/styles/parts/mixins";
  .footer {
    &__text {
      font-size: 12px;
      padding: sl(32) 0;
      color: $text-gray;
      white-space: nowrap;
      @include _1920 {
        padding: 32px 0;
      }
    }
  }
</style>
